import type { CatalogueSnapshot, Neighbourhood, TrackedObject } from './types';
import type { AnalysisRequest } from './analysis.worker';

export interface AnalysisSettings { radiusKm: number; kinds: string; scope: string; country: string; regime: string; debris: boolean; pinnedId: string | null }
export function analysisExport(snapshot: CatalogueSnapshot, selected: TrackedObject, settings: AnalysisSettings, result: unknown, neighbourhood?: Neighbourhood, request?:AnalysisRequest) {
  const byId = new Map(snapshot.objects.map(o => [`catalog_${o.id}`, o]));
  return {
    schema: 'entarian-orbital-analysis/1', exportedAt: new Date().toISOString(),
    source: snapshot.source, revision: snapshot.revision, fetchedAt: snapshot.fetchedAt, coverage: snapshot.coverage,
    units: { range: 'km', rate: 'km/s', time: 'UTC; numeric times are Unix milliseconds' },
    frames: { propagation: 'TEME', globe: 'Earth-fixed using GMST', relative: 'primary radial / in-track / cross-track' },
    solver: 'satellite.js SGP4; 1 s pair scan; 0.1 s numerical refinement',
    limitations: 'Catalogue predictions, not observations. No covariance or calculated collision probability. Numerical precision does not establish physical accuracy.',
    settings: { radiusKm:settings.radiusKm, kinds:settings.kinds, scope:settings.scope, country:settings.country, regime:settings.regime, debris:settings.debris, pinnedId:settings.pinnedId }, selected,
    secondary: settings.pinnedId ? byId.get(settings.pinnedId) : null, result, request,
    objects: neighbourhood?.neighbours.map(n => ({ ...n, noradId: byId.get(n.id)?.id, name: byId.get(n.id)?.name,
      epoch: byId.get(n.id)?.omm.EPOCH, inRange: n.rangeKm <= settings.radiusKm,
      timestamp: new Date(neighbourhood.timestamp).toISOString() })),
  };
}
export function downloadAnalysis(value: unknown, noradId: string, at = Date.now()): void {
  const url = URL.createObjectURL(new Blob([JSON.stringify(value, null, 2)], { type: 'application/json' }));
  const link = document.createElement('a'); link.href = url;
  link.download = `${noradId}-${new Date(at).toISOString().replace(/[:.]/g, '-')}.json`;
  link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
}
